import { NgModule } from '@angular/core';
import { DocumentsLevagesEditablesASupprimerPipe, DocumentsLevagesEditablesEnCoursPipe, DocumentsLevagesEditablesPipe, GetDocumentLevageEditableTitlePipe } from './documents-levages-editables.pipe';



@NgModule({
  declarations: [
    DocumentsLevagesEditablesPipe,
    DocumentsLevagesEditablesEnCoursPipe,
    DocumentsLevagesEditablesASupprimerPipe,
    GetDocumentLevageEditableTitlePipe
  ],
  exports: [
    DocumentsLevagesEditablesPipe,
    DocumentsLevagesEditablesEnCoursPipe,
    DocumentsLevagesEditablesASupprimerPipe,
    GetDocumentLevageEditableTitlePipe
  ]
})
export class DocumentsLevagesEditablesModule { }
